import { PetOnboarding } from './PetOnboarding';
import type { Pet } from '../types/pet';

interface EditPetProfileModalProps {
  pet: Pet;
  onClose: () => void;
}

/** Opens the same 4 sections as Add Pet (Basic Identity, Ownership & Consent, Health & Medical, Lifestyle & Care) in edit mode so the user can update any field. */
export function EditPetProfileModal({
  pet,
  onClose,
}: EditPetProfileModalProps) {
  return (
    <PetOnboarding
      mode="edit"
      editPet={pet}
      onClose={onClose}
      allowMultiple={false}
    />
  );
}
